<!--
 * @Description  : 学校开课明细表
 * @Author       : chenJunHui
 * @LastEditors: chenJunHui
 * @Date         : 2022-09-06 14:02:57
 * @LastEditTime: 2022-11-14 14:49:38
 * @FilePath     : \after_class_service\src\pages\cloudMap\proupTable\schoolPart.vue
-->
<template>
  <div class="indexs">
    <div class="table">
      <!-- 区级表格 -->
      <el-table
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        :border="true"
        :current-page.sync="currentPage"
        :header-cell-style="{ background: '#FAFAFA', color: '#7A8DA2' }"
      >
        <el-table-column prop="orga_name" :label="isSchool?'年级':'学校名称'" align="center">
        </el-table-column>
        <el-table-column prop="course_sum" label="校内课程数" align="center" >
        </el-table-column>
        <el-table-column prop="course_sum_ext" label="校外课程数" align="center" >
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
        style="margintop: 20px; textalign: center"
      >
      </el-pagination>
    </div>
  </div>
</template>
<script>
import cloudMapApi from "@/api/cloudMapApi.js";
import { mapMutations, mapState } from "vuex";
export default {
  props: ["selectParmam"],
  components: {},
  computed: {
    ...mapState(["isSchool"]),
  },
  data() {
    return {
      selectParmams: {},
      org_type: sessionStorage.org_type, // 1:教育局, 2:学校, 8:机构
      tableData: [],
      total: 0,
      currentPage: 1,
      loading: false,
    };
  },
  created() {
  },
  watch: {
    selectParmam(n, o) {
      this.selectParmams = n;
      this.getData();
    },
  },
  mounted() {
    console.log(this.selectParmam,'this.selectParmams');
    this.selectParmams = this.selectParmam
    this.selectParmams.topic = "校";
    this.getData();
  },
  methods: {
    tofixed(row,colum,cellValue){
      if(cellValue!=null){
        return (cellValue * 100).toFixed(2) + '%'
      }
    },
    handleSizeChange(val) {
      this.selectParmams.pagesize = val;
      this.getData();
    },
    handleCurrentChange(val) {
      this.selectParmams.pagenum = val;
      this.getData();
    },
    ...mapMutations(["updateLoadingStatus"]),
    async getData() {
      this.pageNum_1 = 1;
      console.log(this.org_type == '1' , !this.isSchool);
      if(this.org_type == '1' && !this.isSchool){
        this.selectParmams.topic = '校'
      }else{
        this.selectParmams.topic = '年级'
      }
        this.getList_1();
    },
    async getList_1() {
      this.loading = true;
      try {
        let res = await cloudMapApi.shoolStartCourse(this.selectParmams);
        this.tableData = res.data.rows;
        this.total = res.data.total;
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        // this.updateLoadingStatus({ show: false });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.indexs {
  .no_data {
    text-align: center;
    margin: 20px;
  }
  .header {
    width: 100%;
    height: 50px;
    background: #ffffff;
    font-size: 18px;
    line-height: 25px;
    font-weight: bold;
    color: #000000;
    padding: 14px 15px 11px;
  }
  .tabs {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 14px 15px 11px;
    overflow-x: auto;
    flex-wrap: nowrap;
    flex-shrink: 0;

    .tab {
      padding: 5px 15px;
      background: #eff7ff;
      border: 1px solid #beddff;
      border-radius: 24px;
      font-size: 14px;
      line-height: 20px;
      color: #0067da;
      margin-right: 10px;
      flex: 0 0 auto;
    }
  }
}
</style>
